import { createReducer, on } from '@ngrx/store';
import { defaultTransactionListFilter } from '../types/transaction-list-filter';
import {
  fetchTransactionList,
  loadedTransactionList,
  failedTransactionList,
  updateTransactionListFilter,
  resetTransactionList,
} from './transaction-list.actions';
import {
  initialTransactionListState,
  TransactionListState,
  initialDataSource,
} from './transaction-list.state';

export const transactionListReducer = createReducer(
  initialTransactionListState,
  on(fetchTransactionList, (state): TransactionListState => ({ ...state })),
  on(loadedTransactionList, (state, action): TransactionListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedTransactionList, (state): TransactionListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(updateTransactionListFilter, (state, { filter }): TransactionListState => {
    return {
      ...state,
      filter: { ...state.filter, ...(filter ?? defaultTransactionListFilter) },
      dataSource: { ...state.dataSource },
    };
  }),
  on(resetTransactionList, (state): TransactionListState => {
    return {
      ...state,
      filter: { ...defaultTransactionListFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
